import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { ToasterMessageService } from "../services/toaster-message.service";
import { ERROR_HTTP_500 } from "../constants/http-error.constants";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private readonly toasterMessageService: ToasterMessageService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 500) {
          this.toasterMessageService.sendMessage({
            severity: "error",
            summary: "Erreur",
            detail: ERROR_HTTP_500,
            timeout: 5000,
          });
        }
        return throwError(() => error);
      })
    );
  }
}
